const actions = {
  RESET_TOKEN_DATA: 'RESET_TOKEN_DATA',
  RESETTING_TOKEN_DATA: 'RESETTING_TOKEN_DATA',
  RESET_TOKEN_DATA_SUCCESS: 'RESET_TOKEN_DATA_SUCCESS',
  RESET_TOKEN_DATA_FAILED: 'RESET_TOKEN_DATA_FAILED',
  NEW_RESET_MERCHANT_USER_PASSWORD: 'NEW_RESET_MERCHANT_USER_PASSWORD',
  NEW_RESETTING_MERCHANT_USER_PASSWORD: 'NEW_RESETTING_MERCHANT_USER_PASSWORD',
  NEW_MERCHANT_USER_PASSWORD_RESET_SUCCESS: 'NEW_MERCHANT_USER_PASSWORD_RESET_SUCCESS',
  NEW_MERCHANT_USER_PASSWORD_RESET_FAILED: 'NEW_MERCHANT_USER_PASSWORD_RESET_FAILED',
  NEW_MERCHANT_USER_PASSWORD_RESET_ERROR: 'NEW_MERCHANT_USER_PASSWORD_RESET_ERROR',
  NEW_RESET_MERCHANT_USER_PASSWORD_RESET: 'NEW_RESET_MERCHANT_USER_PASSWORD_RESET',
  RESET_ERROR_MESSAGE: 'RESET_ERROR_MESSAGE',

  FETCH_MERCHANT_DATA: 'FETCH_MERCHANT_DATA',
  FETCHING_MERCHANT_DATA: 'FETCHING_MERCHANT_DATA',
  FETCH_MERCHANT_DATA_SUCCESS: 'FETCH_MERCHANT_DATA_SUCCESS',
  FETCH_MERCHANT_DATA_FAILED: 'FETCH_MERCHANT_DATA_FAILED',
  LOADING_MORE_MERCHANT_DATA: 'LOADING_MORE_MERCHANT_DATA',
  RESET_MERCHANT_LIST: 'RESET_MERCHANT_LIST',

  FETCH_MERCHANT_FILES: 'FETCH_MERCHANT_FILES',
  FETCHING_MERCHANT_FILES: 'FETCHING_MERCHANT_FILES',
  FETCH_MERCHANT_FILES_SUCCESS: 'FETCH_MERCHANT_FILES_SUCCESS',
  FETCH_MERCHANT_FILES_FAILED: 'FETCH_MERCHANT_FILES_FAILED',
  LOADING_MORE_MERCHANT_FILES: 'LOADING_MORE_MERCHANT_FILES',
  RESET_MERCHANT_FILES: 'RESET_MERCHANT_FILES',

  FETCH_PTI_TEST_MERCHANT_USERS: 'FETCH_PTI_TEST_MERCHANT_USERS',
  FETCHING_PTI_TEST_MERCHANT_USERS: 'FETCHING_PTI_TEST_MERCHANT_USERS',
  FETCH_PTI_TEST_MERCHANT_USERS_SUCCESS: 'FETCH_PTI_TEST_MERCHANT_USERS_SUCCESS',
  FETCH_PTI_TEST_MERCHANT_USERS_FAILED: 'FETCH_PTI_TEST_MERCHANT_USERS_FAILED',
  LOADING_MORE_PTI_TEST_MERCHANT_USERS: 'LOADING_MORE_PTI_TEST_MERCHANT_USERS',
  RESET_PTI_TEST_MERCHANT_USERS: 'RESET_PTI_TEST_MERCHANT_USERS',

  FETCH_PTI_PROD_MERCHANT_USERS: 'FETCH_PTI_PROD_MERCHANT_USERS',
  FETCHING_PTI_PROD_MERCHANT_USERS: 'FETCHING_PTI_PROD_MERCHANT_USERS',
  FETCH_PTI_PROD_MERCHANT_USERS_SUCCESS: 'FETCH_PTI_PROD_MERCHANT_USERS_SUCCESS',
  FETCH_PTI_PROD_MERCHANT_USERS_FAILED: 'FETCH_PTI_PROD_MERCHANT_USERS_FAILED',
  LOADING_MORE_PTI_PROD_MERCHANT_USERS: 'LOADING_MORE_PTI_PROD_MERCHANT_USERS',
  RESET_PTI_PROD_MERCHANT_USERS: 'RESET_PTI_PROD_MERCHANT_USERS',

  FETCH_PTI_MERCHANT_USERS: 'FETCH_PTI_MERCHANT_USERS',
  FETCHING_PTI_MERCHANT_USERS: 'FETCHING_PTI_MERCHANT_USERS',
  FETCH_PTI_MERCHANT_USERS_SUCCESS: 'FETCH_PTI_MERCHANT_USERS_SUCCESS',
  FETCH_PTI_MERCHANT_USERS_FAILED: 'FETCH_PTI_MERCHANT_USERS_FAILED',

  LOADING_MORE_PTI_MERCHANT_USERS: 'LOADING_MORE_PTI_MERCHANT_USERS',

  FETCH_MERCHANT_CONFIG_DATA: 'FETCH_MERCHANT_CONFIG_DATA',
  FETCHING_MERCHANT_CONFIG_DATA: 'FETCHING_MERCHANT_CONFIG_DATA',
  FETCH_MERCHANT_CONFIG_DATA_SUCCESS: 'FETCH_MERCHANT_CONFIG_DATA_SUCCESS',
  FETCH_MERCHANT_CONFIG_DATA_FAILED: 'FETCH_MERCHANT_CONFIG_DATA_FAILED',
  RESET_MERCHANT_CONFIG_DATA: 'RESET_MERCHANT_CONFIG_DATA',

  FETCH_MERCHANT_SETTINGS_TYPE_DATA: 'FETCH_MERCHANT_SETTINGS_TYPE_DATA',
  FETCHING_MERCHANT_SETTINGS_TYPE_DATA: 'FETCHING_MERCHANT_SETTINGS_TYPE_DATA',
  FETCH_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS: 'FETCH_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS',
  FETCH_MERCHANT_SETTINGS_TYPE_DATA_FAILED: 'FETCH_MERCHANT_SETTINGS_TYPE_DATA_FAILED',
  RESET_MERCHANT_SETTINGS_TYPE_DATA: 'RESET_MERCHANT_SETTINGS_TYPE_DATA',

  FETCH_PARENT_MERCHANT_DATA: 'FETCH_PARENT_MERCHANT_DATA',
  FETCHING_PARENT_MERCHANT_DATA: 'FETCHING_PARENT_MERCHANT_DATA',
  FETCH_PARENT_MERCHANT_DATA_SUCCESS: 'FETCH_PARENT_MERCHANT_DATA_SUCCESS',
  FETCH_PARENT_MERCHANT_DATA_FAILED: 'FETCH_PARENT_MERCHANT_DATA_FAILED',

  FETCH_ELASTIC_MERCHANT_DATA: 'FETCH_ELASTIC_MERCHANT_DATA',
  FETCHING_ELASTIC_MERCHANT_DATA: 'FETCHING_ELASTIC_MERCHANT_DATA',
  FETCH_ELASTIC_MERCHANT_DATA_SUCCESS: 'FETCH_ELASTIC_MERCHANT_DATA_SUCCESS',
  FETCH_ELASTIC_MERCHANT_DATA_FAILED: 'FETCH_ELASTIC_MERCHANT_DATA_FAILED',

  FETCH_MERCHANT_DATA_BY_ID: 'FETCH_MERCHANT_DATA_BY_ID',
  FETCHING_MERCHANT_DATA_BY_ID: 'FETCHING_MERCHANT_DATA_BY_ID',
  FETCH_MERCHANT_DATA_BY_ID_SUCCESS: 'FETCH_MERCHANT_DATA_BY_ID_SUCCESS',
  FETCH_MERCHANT_DATA_BY_ID_FAILED: 'FETCH_MERCHANT_DATA_BY_ID_FAILED',
  RESET_MERCHANT_DATA: 'RESET_MERCHANT_DATA',
  RESET_MERCHANT_INFORMATION_DATA: 'RESET_MERCHANT_INFORMATION_DATA',

  FETCH_MERCHANT_PCHANNEL_DATA_BY_ID: 'FETCH_MERCHANT_PCHANNEL_DATA_BY_ID',
  FETCHING_MERCHANT_PCHANNEL_DATA_BY_ID: 'FETCHING_MERCHANT_PCHANNEL_DATA_BY_ID',
  FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_SUCCESS: 'FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_SUCCESS',
  FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED: 'FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED',
  RESET_MERCHANT_PCHANNEL_DATA: 'RESET_MERCHANT_PCHANNEL_DATA',

  FETCH_MERCHANT_LOGS_DATA_BY_ID: 'FETCH_MERCHANT_LOGS_DATA_BY_ID',
  FETCHING_MERCHANT_LOGS_DATA_BY_ID: 'FETCHING_MERCHANT_LOGS_DATA_BY_ID',
  FETCH_MERCHANT_LOGS_DATA_BY_ID_SUCCESS: 'FETCH_MERCHANT_LOGS_DATA_BY_ID_SUCCESS',
  FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED: 'FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED',
  RESET_MERCHANT_LOGS_DATA: 'RESET_MERCHANT_LOGS_DATA',

  ADD_MERCHANT_DATA: 'ADD_MERCHANT_DATA',
  ADDING_MERCHANT_DATA: 'ADDING_MERCHANT_DATA',
  ADD_MERCHANT_DATA_SUCCESS: 'ADD_MERCHANT_DATA_SUCCESS',
  ADD_MERCHANT_DATA_FAILED: 'ADD_MERCHANT_DATA_FAILED',

  ADD_PTI_DASHBOARD_USER: 'ADD_PTI_DASHBOARD_USER',
  ADDING_PTI_DASHBOARD_USER: 'ADDING_PTI_DASHBOARD_USER',
  ADD_PTI_DASHBOARD_USER_SUCCESS: 'ADD_PTI_DASHBOARD_USER_SUCCESS',
  ADD_PTI_DASHBOARD_USER_FAILED: 'ADD_PTI_DASHBOARD_USER_FAILED',

  UPDATE_PTI_DASHBOARD_USER: 'UPDATE_PTI_DASHBOARD_USER',
  UPDATING_PTI_DASHBOARD_USER: 'UPDATING_PTI_DASHBOARD_USER',
  UPDATE_PTI_DASHBOARD_USER_SUCCESS: 'UPDATE_PTI_DASHBOARD_USER_SUCCESS',
  UPDATE_PTI_DASHBOARD_USER_FAILED: 'UPDATE_PTI_DASHBOARD_USER_FAILED',

  REGISTER_PTI_DASHBOARD_USER: 'REGISTER_PTI_DASHBOARD_USER',
  REGISTERING_PTI_DASHBOARD_USER: 'REGISTERING_PTI_DASHBOARD_USER',
  REGISTER_PTI_DASHBOARD_USER_SUCCESS: 'REGISTER_PTI_DASHBOARD_USER_SUCCESS',
  REGISTER_PTI_DASHBOARD_USER_FAILED: 'REGISTER_PTI_DASHBOARD_USER_FAILED',

  FETCH_INVITED_MERCHANT_USER_DATA: 'FETCH_INVITED_MERCHANT_USER_DATA',
  FETCHING_INVITED_MERCHANT_USER_DATA: 'FETCHING_INVITED_MERCHANT_USER_DATA',
  FETCH_INVITED_MERCHANT_USER_DATA_SUCCESS: 'FETCH_INVITED_MERCHANT_USER_DATA_SUCCESS',
  FETCH_INVITED_MERCHANT_USER_DATA_FAILED: 'FETCH_INVITED_MERCHANT_USER_DATA_FAILED',

  INVITE_MERCHANT_DATA: 'INVITE_MERCHANT_DATA',
  INVITING_MERCHANT_DATA: 'INVITING_MERCHANT_DATA',
  INVITE_MERCHANT_DATA_SUCCESS: 'INVITE_MERCHANT_DATA_SUCCESS',
  INVITE_MERCHANT_DATA_FAILED: 'INVITE_MERCHANT_DATA_FAILED',

  FETCH_INVITED_MERCHANT_DATA: 'FETCH_INVITED_MERCHANT_DATA',
  FETCHING_INVITED_MERCHANT_DATA: 'FETCHING_INVITED_MERCHANT_DATA',
  FETCH_INVITED_MERCHANT_DATA_SUCCESS: 'FETCH_INVITED_MERCHANT_DATA_SUCCESS',
  FETCH_INVITED_MERCHANT_DATA_FAILED: 'FETCH_INVITED_MERCHANT_DATA_FAILED',

  LOG_ACCESS_MERCHANT_INVITE_DATA: 'LOG_ACCESS_MERCHANT_INVITE_DATA',
  LOGGING_ACCESS_MERCHANT_INVITE_DATA: 'LOGGING_ACCESS_MERCHANT_INVITE_DATA',
  LOG_ACCESS_MERCHANT_INVITE_DATA_SUCCESS: 'LOG_ACCESS_MERCHANT_INVITE_DATA_SUCCESS',
  LOG_ACCESS_MERCHANT_INVITE_DATA_FAILED: 'LOG_ACCESS_MERCHANT_INVITE_DATA_FAILED',

  EDIT_MIGRATED_MID: 'EDIT_MIGRATED_MID',
  EDITING_MIGRATED_MID: 'EDITING_MIGRATED_MID',
  EDIT_MIGRATED_MID_SUCCESS: 'EDIT_MIGRATED_MID_SUCCESS',
  EDIT_MIGRATED_MID_FAILED: 'EDIT_MIGRATED_MID_FAILED',

  EDIT_MERCHANT_BASIC_INFORMATION_DATA: 'EDIT_MERCHANT_BASIC_INFORMATION_DATA',
  EDITING_MERCHANT_BASIC_INFORMATION_DATA: 'EDITING_MERCHANT_BASIC_INFORMATION_DATA',
  EDIT_MERCHANT_BASIC_INFORMATION_DATA_SUCCESS: 'EDIT_MERCHANT_BASIC_INFORMATION_DATA_SUCCESS',
  EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED: 'EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED',

  EDIT_MERCHANT_OWNER_INFORMATION_DATA: 'EDIT_MERCHANT_OWNER_INFORMATION_DATA',
  EDITING_MERCHANT_OWNER_INFORMATION_DATA: 'EDITING_MERCHANT_OWNER_INFORMATION_DATA',
  EDIT_MERCHANT_OWNER_INFORMATION_DATA_SUCCESS: 'EDIT_MERCHANT_OWNER_INFORMATION_DATA_SUCCESS',
  EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED: 'EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED',

  EDIT_MERCHANT_CONTACT_INFORMATION_DATA: 'EDIT_MERCHANT_CONTACT_INFORMATION_DATA',
  EDITING_MERCHANT_CONTACT_INFORMATION_DATA: 'EDITING_MERCHANT_CONTACT_INFORMATION_DATA',
  EDIT_MERCHANT_CONTACT_INFORMATION_DATA_SUCCESS: 'EDIT_MERCHANT_CONTACT_INFORMATION_DATA_SUCCESS',
  EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED: 'EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED',

  EDIT_MERCHANT_SERVICE_INFORMATION_DATA: 'EDIT_MERCHANT_SERVICE_INFORMATION_DATA',
  EDITING_MERCHANT_SERVICE_INFORMATION_DATA: 'EDITING_MERCHANT_SERVICE_INFORMATION_DATA',
  EDIT_MERCHANT_SERVICE_INFORMATION_DATA_SUCCESS: 'EDIT_MERCHANT_SERVICE_INFORMATION_DATA_SUCCESS',
  EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED: 'EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED',

  EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA: 'EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA',
  EDITING_MERCHANT_PCHANNEL_INFORMATION_DATA: 'EDITING_MERCHANT_PCHANNEL_INFORMATION_DATA',
  EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_SUCCESS:
    'EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_SUCCESS',
  EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED: 'EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED',

  DELETE_MERCHANT_DATA: 'DELETE_MERCHANT_DATA',
  DELETING_MERCHANT_DATA: 'DELETING_MERCHANT_DATA',
  DELETE_MERCHANT_DATA_SUCCESS: 'DELETE_MERCHANT_DATA_SUCCESS',
  DELETE_MERCHANT_DATA_FAILED: 'DELETE_MERCHANT_DATA_FAILED',

  FILTER_MERCHANT: 'FILTER_MERCHANT',
  FILTERING_MERCHANT: 'FILTERING_MERCHANT',
  FILTER_MERCHANT_SUCCESS: 'FILTER_MERCHANT_SUCCESS',
  FILTER_MERCHANT_FAILED: 'FILTER_MERCHANT_FAILED',

  FETCH_MERCHANT_AMOUNT_LEVEL_DATA: 'FETCH_MERCHANT_AMOUNT_LEVEL_DATA',
  FETCHING_MERCHANT_AMOUNT_LEVEL_DATA: 'FETCHING_MERCHANT_AMOUNT_LEVEL_DATA',
  FETCH_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS: 'FETCH_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS',
  FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED: 'FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED',

  FETCH_FILE_MANAGEMENT_DATA: 'FETCH_FILE_MANAGEMENT_DATA',
  FETCHING_FILE_MANAGEMENT_DATA: 'FETCHING_FILE_MANAGEMENT_DATA',
  FETCH_FILE_MANAGEMENT_DATA_SUCCESS: 'FETCH_FILE_MANAGEMENT_DATA_SUCCESS',
  FETCH_FILE_MANAGEMENT_DATA_FAILED: 'FETCH_FILE_MANAGEMENT_DATA_FAILED',
  RESET_FILE_MANAGEMENT_DATA: 'RESET_FILE_MANAGEMENT_DATA',

  UPLOAD_FILE_DATA: 'UPLOAD_FILE_DATA',
  UPLOADING_FILE_DATA: 'UPLOADING_FILE_DATA',
  UPLOAD_FILE_DATA_SUCCESS: 'UPLOAD_FILE_DATA_SUCCESS',
  UPLOAD_FILE_DATA_FAILED: 'UPLOAD_FILE_DATA_FAILED',

  DOWNLOAD_FILE_DATA: 'DOWNLOAD_FILE_DATA',
  DOWNLOADING_FILE_DATA: 'DOWNLOADING_FILE_DATA',
  DOWNLOAD_FILE_DATA_SUCCESS: 'DOWNLOAD_FILE_DATA_SUCCESS',
  DOWNLOAD_FILE_DATA_FAILED: 'DOWNLOAD_FILE_DATA_FAILED',
  REMOVE_FILE_DATA_STORAGE: 'REMOVE_FILE_DATA_STORAGE',

  DELETE_FILE_DATA: 'DELETE_FILE_DATA',
  DELETING_FILE_DATA: 'DELETING_FILE_DATA',
  DELETE_FILE_DATA_SUCCESS: 'DELETE_FILE_DATA_SUCCESS',
  DELETE_FILE_DATA_FAILED: 'DELETE_FILE_DATA_FAILED',

  ADD_MERCHANT_SETTINGS_TYPE: 'ADD_MERCHANT_SETTINGS_TYPE',
  ADDING_MERCHANT_SETTINGS_TYPE: 'ADDING_MERCHANT_SETTINGS_TYPE',
  ADD_MERCHANT_SETTINGS_TYPE_SUCCESS: 'ADD_MERCHANT_SETTINGS_TYPE_SUCCESS',
  ADD_MERCHANT_SETTINGS_TYPE_FAILED: 'ADD_MERCHANT_SETTINGS_TYPE_FAILED',

  ADD_AMOUNT_LEVEL: 'ADD_AMOUNT_LEVEL',
  ADDING_AMOUNT_LEVEL: 'ADDING_AMOUNT_LEVEL',
  ADD_AMOUNT_LEVEL_SUCCESS: 'ADD_AMOUNT_LEVEL_SUCCESS',
  ADD_AMOUNT_LEVEL_FAILED: 'ADD_AMOUNT_LEVEL_FAILED',

  EDIT_MERCHANT_SETTINGS_TYPE_DATA: 'EDIT_MERCHANT_SETTINGS_TYPE_DATA',
  EDITING_MERCHANT_SETTINGS_TYPE_DATA: 'EDITING_MERCHANT_SETTINGS_TYPE_DATA',
  EDIT_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS: 'EDIT_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS',
  EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED: 'EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED',

  EDIT_MERCHANT_AMOUNT_LEVEL_DATA: 'EDIT_MERCHANT_AMOUNT_LEVEL_DATA',
  EDITING_MERCHANT_AMOUNT_LEVEL_DATA: 'EDITING_MERCHANT_AMOUNT_LEVEL_DATA',
  EDIT_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS: 'EDIT_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS',
  EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED: 'EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED',

  ADD_MERCHANT_CONFIGURATION_DATA: 'ADD_MERCHANT_CONFIGURATION_DATA',
  ADDING_MERCHANT_CONFIGURATION_DATA: 'ADDING_MERCHANT_CONFIGURATION_DATA',
  ADD_MERCHANT_CONFIGURATION_DATA_SUCCESS: 'ADD_MERCHANT_CONFIGURATION_DATA_SUCCESS',
  ADD_MERCHANT_CONFIGURATION_DATA_FAILED: 'ADD_MERCHANT_CONFIGURATION_DATA_FAILED',

  EDIT_MERCHANT_CONFIG_DATA: 'EDIT_MERCHANT_CONFIG_DATA',
  EDITING_MERCHANT_CONFIG_DATA: 'EDITING_MERCHANT_CONFIG_DATA',
  EDIT_MERCHANT_CONFIG_DATA_SUCCESS: 'EDIT_MERCHANT_CONFIG_DATA_SUCCESS',
  EDIT_MERCHANT_CONFIG_DATA_FAILED: 'EDIT_MERCHANT_CONFIG_DATA_FAILED',

  FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA: 'FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA',
  FETCHING_MERCHANT_PCHANNEL_CREDENTIAL_DATA: 'FETCHING_MERCHANT_PCHANNEL_CREDENTIAL_DATA',
  FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS:
    'FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS',
  FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED: 'FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED',

  FETCH_MERCHANT_FEE_DATA: 'FETCH_MERCHANT_FEE_DATA',
  FETCHING_MERCHANT_FEE_DATA: 'FETCHING_MERCHANT_FEE_DATA',
  FETCH_MERCHANT_FEE_DATA_SUCCESS: 'FETCH_MERCHANT_FEE_DATA_SUCCESS',
  FETCH_MERCHANT_FEE_DATA_FAILED: 'FETCH_MERCHANT_FEE_DATA_FAILED',

  SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA: 'SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA',
  SETTING_UP_MERCHANT_PCHANNEL_CREDENTIAL_DATA: 'SETTING_UP_MERCHANT_PCHANNEL_CREDENTIAL_DATA',
  SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS:
    'SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS',
  SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED: 'SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED',

  SETUP_MERCHANT_FEE_DATA: 'SETUP_MERCHANT_FEE_DATA',
  SETTING_UP_MERCHANT_FEE_DATA: 'SETTING_UP_MERCHANT_FEE_DATA',
  SETUP_MERCHANT_FEE_DATA_SUCCESS: 'SETUP_MERCHANT_FEE_DATA_SUCCESS',
  SETUP_MERCHANT_FEE_DATA_FAILED: 'SETUP_MERCHANT_FEE_DATA_FAILED',

  ADD_MERCHANT_INFORMATION: 'ADD_MERCHANT_INFORMATION',
  ADDING_MERCHANT_INFORMATION: 'ADDING_MERCHANT_INFORMATION',
  ADD_MERCHANT_INFORMATION_SUCCESS: 'ADD_MERCHANT_INFORMATION_SUCCESS',
  ADD_MERCHANT_INFORMATION_FAILED: 'ADD_MERCHANT_INFORMATION_FAILED',

  FETCH_ALL_MERCHANT_INFORMATION: 'FETCH_ALL_MERCHANT_INFORMATION',
  FETCHING_ALL_MERCHANT_INFORMATION: 'FETCHING_ALL_MERCHANT_INFORMATION',
  FETCH_ALL_MERCHANT_INFORMATION_SUCCESS: 'FETCH_ALL_MERCHANT_INFORMATION_SUCCESS',
  FETCH_ALL_MERCHANT_INFORMATION_FAILED: 'FETCH_ALL_MERCHANT_INFORMATION_FAILED',

  FETCH_MERCHANT_INFO_BY_ID: 'FETCH_MERCHANT_INFO_BY_ID',
  FETCHING_MERCHANT_INFO_BY_ID: 'FETCHING_MERCHANT_INFO_BY_ID',
  FETCH_MERCHANT_INFO_BY_ID_SUCCESS: 'FETCH_MERCHANT_INFO_BY_ID_SUCCESS',
  FETCH_MERCHANT_INFO_BY_ID_FAILED: 'FETCH_MERCHANT_INFO_BY_ID_FAILED',

  EDIT_MERCHANT_INFO: 'EDIT_MERCHANT_INFO',
  EDITING_MERCHANT_INFO: 'EDITING_MERCHANT_INFO',
  EDIT_MERCHANT_INFO_SUCCESS: 'EDIT_MERCHANT_INFO_SUCCESS',
  EDIT_MERCHANT_INFO_FAILED: 'EDIT_MERCHANT_INFO_FAILED',

  FETCH_MIS_OPTIONS: 'FETCH_MIS_OPTIONS',
  FETCHING_MIS_OPTIONS: 'FETCHING_MIS_OPTIONS',
  FETCH_MIS_OPTIONS_SUCCESS: 'FETCH_MIS_OPTIONS_SUCCESS',
  FETCH_MIS_OPTIONS_FAILED: 'FETCH_MIS_OPTIONS_FAILED',

  FETCH_MIS_MERCHANT_DETAILS: 'FETCH_MIS_MERCHANT_DETAILS',
  FETCHING_MIS_MERCHANT_DETAILS: 'FETCHING_MIS_MERCHANT_DETAILS',
  FETCH_MIS_MERCHANT_DETAILS_SUCCESS: 'FETCH_MIS_MERCHANT_DETAILS_SUCCESS',
  FETCH_MIS_MERCHANT_DETAILS_FAILED: 'FETCH_MIS_MERCHANT_DETAILS_FAILED',

  FETCH_KYB_LINK_STATUS: 'FETCH_KYB_LINK_STATUS',
  FETCHING_KYB_LINK_STATUS: 'FETCHING_KYB_LINK_STATUS',
  FETCH_KYB_LINK_STATUS_SUCCESS: 'FETCH_KYB_LINK_STATUS_SUCCESS',
  FETCH_KYB_LINK_STATUS_FAILED: 'FETCH_KYB_LINK_STATUS_FAILED',

  LOG_ACCESS_MIS: 'LOG_ACCESS_MIS',
  LOGGING_ACCESS_MIS: 'LOGGING_ACCESS_MIS',
  LOG_ACCESS_MIS_SUCCESS: 'LOG_ACCESS_MIS_SUCCESS',
  LOG_ACCESS_MIS_FAILED: 'LOG_ACCESS_MIS_FAILED',

  SUBMIT_MIS_FORM_DATA: 'SUBMIT_MIS_FORM_DATA',
  SUBMITTING_MIS_FORM_DATA: 'SUBMITTING_MIS_FORM_DATA',
  SUBMIT_MIS_FORM_DATA_SUCCESS: 'SUBMIT_MIS_FORM_DATA_SUCCESS',
  SUBMIT_MIS_FORM_DATA_FAILED: 'SUBMIT_MIS_FORM_DATA_FAILED',

  SAVE_MIS_DRAFT: 'SAVE_MIS_DRAFT',
  SAVING_MIS_DRAFT: 'SAVING_MIS_DRAFT',
  SAVE_MIS_DRAFT_SUCCESS: 'SAVE_MIS_DRAFT_SUCCESS',
  SAVE_MIS_DRAFT_FAILED: 'SAVE_MIS_DRAFT_FAILED',

  FETCH_ALL_MERCHANT_FROM_ONBOARDING: 'FETCH_ALL_MERCHANT_FROM_ONBOARDING',
  FETCHING_ALL_MERCHANT_FROM_ONBOARDING: 'FETCHING_ALL_MERCHANT_FROM_ONBOARDING',
  FETCH_ALL_MERCHANT_FROM_ONBOARDING_SUCCESS: 'FETCH_ALL_MERCHANT_FROM_ONBOARDING_SUCCESS',
  FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED: 'FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED',
  LOADING_MORE_MERCHANT_FROM_ONBOARDING: 'LOADING_MORE_MERCHANT_FROM_ONBOARDING',

  FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS: 'FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS',
  FETCHING_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS:
    'FETCHING_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS',
  FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_SUCCESS:
    'FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_SUCCESS',
  FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED:
    'FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED',

  EDIT_MERCHANT_SERVICE: 'EDIT_MERCHANT_SERVICE',
  EDITING_MERCHANT_SERVICE: 'EDITING_MERCHANT_SERVICE',
  EDIT_MERCHANT_SERVICE_SUCCESS: 'EDIT_MERCHANT_SERVICE_SUCCESS',
  EDIT_MERCHANT_SERVICE_FAILED: 'EDIT_MERCHANT_SERVICE_FAILED',

  EDIT_MERCHANT_PAYMENT_CHANNEL: 'EDIT_MERCHANT_PAYMENT_CHANNEL',
  EDITING_MERCHANT_PAYMENT_CHANNEL: 'EDITING_MERCHANT_PAYMENT_CHANNEL',
  EDIT_MERCHANT_PAYMENT_CHANNEL_SUCCESS: 'EDIT_MERCHANT_PAYMENT_CHANNEL_SUCCESS',
  EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED: 'EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED',

  FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS: 'FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS',
  FETCHING_ALL_COSMOS_LEADS_AND_MERCHANTS: 'FETCHING_ALL_COSMOS_LEADS_AND_MERCHANTS',
  FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_SUCCESS: 'FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_SUCCESS',
  FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_FAILED: 'FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_FAILED',
  LOADING_MORE_LEADS_AND_MERCHANTS: 'LOADING_MORE_LEADS_AND_MERCHANTS',

  FETCH_EXISTING_MERCHANT_LOGS: 'FETCH_EXISTING_MERCHANT_LOGS',
  LOADING_MORE_EXISTING_MERCHANT_LOGS: 'LOADING_MORE_EXISTING_MERCHANT_LOGS',
  FETCHING_EXISTING_MERCHANT_LOGS: 'FETCHING_EXISTING_MERCHANT_LOGS',
  FETCH_EXISTING_MERCHANT_LOGS_SUCCESS: 'FETCH_EXISTING_MERCHANT_LOGS_SUCCESS',
  FETCH_EXISTING_MERCHANT_LOGS_FAILED: 'FETCH_EXISTING_MERCHANT_LOGS_FAILED',
  RESET_EXISTING_MERCHANT_LOGS: 'RESET_EXISTING_MERCHANT_LOGS',

  // start: company information
  FETCH_COMPANY_INFORMATION_DATA: 'FETCH_COMPANY_INFORMATION_DATA',
  FETCHING_COMPANY_INFORMATION_DATA: 'FETCHING_COMPANY_INFORMATION_DATA',
  FETCH_COMPANY_INFORMATION_DATA_SUCCESS: 'FETCH_COMPANY_INFORMATION_DATA_SUCCESS',
  FETCH_COMPANY_INFORMATION_DATA_FAILED: 'FETCH_COMPANY_INFORMATION_DATA_FAILED',

  ADD_COMPANY_INFORMATION: 'ADD_COMPANY_INFORMATION',
  ADDING_COMPANY_INFORMATION: 'ADDING_COMPANY_INFORMATION',
  ADD_COMPANY_INFORMATION_SUCCESS: 'ADD_COMPANY_INFORMATION_SUCCESS',
  ADD_COMPANY_INFORMATION_FAILED: 'ADD_COMPANY_INFORMATION_FAILED',

  EDIT_COMPANY_INFORMATION: 'EDIT_COMPANY_INFORMATION',
  EDITING_COMPANY_INFORMATION: 'EDITING_COMPANY_INFORMATION',
  EDIT_COMPANY_INFORMATION_SUCCESS: 'EDIT_COMPANY_INFORMATION_SUCCESS',
  EDIT_COMPANY_INFORMATION_FAILED: 'EDIT_COMPANY_INFORMATION_FAILED',

  DOWNLOAD_MERCHANT_FILE: 'DOWNLOAD_MERCHANT_FILE',
  DOWNLOADING_MERCHANT_FILE: 'DOWNLOADING_MERCHANT_FILE',
  DOWNLOAD_MERCHANT_FILE_SUCCESS: 'DOWNLOAD_MERCHANT_FILE_SUCCESS',
  DOWNLOAD_MERCHANT_FILE_FAILED: 'DOWNLOAD_MERCHANT_FILE_FAILED',

  FETCH_ALL_PARENT_MERCHANTS: 'FETCH_ALL_PARENT_MERCHANTS',
  FETCHING_ALL_PARENT_MERCHANTS: 'FETCHING_ALL_PARENT_MERCHANTS',
  FETCH_ALL_PARENT_MERCHANTS_SUCCESS: 'FETCH_ALL_PARENT_MERCHANTS_SUCCESS',
  FETCH_ALL_PARENT_MERCHANTS_FAILED: 'FETCH_ALL_PARENT_MERCHANTS_FAILED',

  MIGRATE_MERCHANT_INFORMATION: 'MIGRATE_MERCHANT_INFORMATION',
  MIGRATING_MERCHANT_INFORMATION: 'MIGRATING_MERCHANT_INFORMATION',
  MIGRATE_MERCHANT_INFORMATION_SUCCESS: 'MIGRATE_MERCHANT_INFORMATION_SUCCESS',
  MIGRATE_MERCHANT_INFORMATION_FAILED: 'MIGRATE_MERCHANT_INFORMATION_FAILED',

  FETCH_PAYBIZ_DETAILS_BY_ID: 'FETCH_PAYBIZ_DETAILS_BY_ID',
  FETCHING_PAYBIZ_DETAILS_BY_ID: 'FETCHING_PAYBIZ_DETAILS_BY_ID',
  FETCH_PAYBIZ_DETAILS_BY_ID_SUCCESS: 'FETCH_PAYBIZ_DETAILS_BY_ID_SUCCESS',
  FETCH_PAYBIZ_DETAILS_BY_ID_FAILED: 'FETCH_PAYBIZ_DETAILS_BY_ID_FAILED',
  RESET_PAYBIZ_DETAILS: 'RESET_PAYBIZ_DETAILS',

  FETCH_PAYBIZ_MERCHANTS: 'FETCH_PAYBIZ_MERCHANTS',
  FETCHING_PAYBIZ_MERCHANTS: 'FETCHING_PAYBIZ_MERCHANTS',
  FETCH_PAYBIZ_MERCHANTS_SUCCESS: 'FETCH_PAYBIZ_MERCHANTS_SUCCESS',
  FETCH_PAYBIZ_MERCHANTS_FAILED: 'FETCH_PAYBIZ_MERCHANTS_FAILED',

  FETCH_MERCHANT_INFO_MIDS: 'FETCH_MERCHANT_INFO_MIDS',
  FETCHING_MERCHANT_INFO_MIDS: 'FETCHING_MERCHANT_INFO_MIDS',
  FETCH_MERCHANT_INFO_MIDS_SUCCESS: 'FETCH_MERCHANT_INFO_MIDS_SUCCESS',
  FETCH_MERCHANT_INFO_MIDS_FAILED: 'FETCH_MERCHANT_INFO_MIDS_FAILED',

  FETCH_INTEGRATION_FORM_REQUESTS: 'FETCH_INTEGRATION_FORM_REQUESTS',
  LOADING_MORE_INTEGRATION_FORM_REQUESTS: 'LOADING_MORE_INTEGRATION_FORM_REQUESTS',
  FETCHING_INTEGRATION_FORM_REQUESTS: 'FETCHING_INTEGRATION_FORM_REQUESTS',
  FETCH_INTEGRATION_FORM_REQUESTS_SUCCESS: 'FETCH_INTEGRATION_FORM_REQUESTS_SUCCESS',
  FETCH_INTEGRATION_FORM_REQUESTS_FAILED: 'FETCH_INTEGRATION_FORM_REQUESTS_FAILED',

  FETCH_INTEGRATION_FORM_REQUEST_BY_ID: 'FETCH_INTEGRATION_FORM_REQUEST_BY_ID',
  FETCHING_INTEGRATION_FORM_REQUEST_BY_ID: 'FETCHING_INTEGRATION_FORM_REQUEST_BY_ID',
  FETCH_INTEGRATION_FORM_REQUEST_BY_ID_SUCCESS: 'FETCH_INTEGRATION_FORM_REQUEST_BY_ID_SUCCESS',
  FETCH_INTEGRATION_FORM_REQUEST_BY_ID_FAILED: 'FETCH_INTEGRATION_FORM_REQUEST_BY_ID_FAILED',
  RESET_INTEGRATION_FORM_REQUEST_BY_ID: 'RESET_INTEGRATION_FORM_REQUEST_BY_ID',

  EDIT_INTEGRATION_CHANNEL_SUB_MID: 'EDIT_INTEGRATION_CHANNEL_SUB_MID',
  EDITING_INTEGRATION_CHANNEL_SUB_MID: 'EDITING_INTEGRATION_CHANNEL_SUB_MID',
  EDIT_INTEGRATION_CHANNEL_SUB_MID_SUCCESS: 'EDIT_INTEGRATION_CHANNEL_SUB_MID_SUCCESS',
  EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED: 'EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED',

  UPDATE_INTEGRATION_FORM_REQUEST_STATUS: 'UPDATE_INTEGRATION_FORM_REQUEST_STATUS',
  UPDATING_INTEGRATION_FORM_REQUEST_STATUS: 'UPDATING_INTEGRATION_FORM_REQUEST_STATUS',
  UPDATE_INTEGRATION_FORM_REQUEST_STATUS_SUCCESS: 'UPDATE_INTEGRATION_FORM_REQUEST_STATUS_SUCCESS',
  UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED: 'UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED',

  ASSIGN_TOS_TO_IRF: 'ASSIGN_TOS_TO_IRF',
  ASSIGNING_TOS_TO_IRF: 'ASSIGNING_TOS_TO_IRF',
  ASSIGN_TOS_TO_IRF_SUCCESS: 'ASSIGN_TOS_TO_IRF_SUCCESS',
  ASSIGN_TOS_TO_IRF_FAILED: 'ASSIGN_TOS_TO_IRF_FAILED',

  GENERATE_INTEGRATION_REQUEST_FORM_REPORT: 'GENERATE_INTEGRATION_REQUEST_FORM_REPORT',
  GENERATING_INTEGRATION_REQUEST_FORM_REPORT: 'GENERATING_INTEGRATION_REQUEST_FORM_REPORT',
  GENERATE_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS:
    'GENERATE_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS',
  GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED:
    'GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED',

  DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT: 'DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT',
  DOWNLOADING_INTEGRATION_REQUEST_FORM_REPORT: 'DOWNLOADING_INTEGRATION_REQUEST_FORM_REPORT',
  DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS:
    'DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS',
  DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED:
    'DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED',

  FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA: 'FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA',
  FETCHING_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA:
    'FETCHING_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA',
  FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_SUCCESS:
    'FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_SUCCESS',
  FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_FAILED:
    'FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_FAILED',

  FETCH_INTEGRATION_FORM_LOGS: 'FETCH_INTEGRATION_FORM_LOGS',
  LOADING_MORE_INTEGRATION_FORM_LOGS: 'LOADING_MORE_INTEGRATION_FORM_LOGS',
  FETCHING_INTEGRATION_FORM_LOGS: 'FETCHING_INTEGRATION_FORM_LOGS',
  FETCH_INTEGRATION_FORM_LOGS_SUCCESS: 'FETCH_INTEGRATION_FORM_LOGS_SUCCESS',
  FETCH_INTEGRATION_FORM_LOGS_FAILED: 'FETCH_INTEGRATION_FORM_LOGS_FAILED',
  PUSH_INTEGRATION_FORM_LOGS: 'PUSH_INTEGRATION_FORM_LOGS',
  RESET_INTEGRATION_FORM_LOGS: 'RESET_INTEGRATION_FORM_LOGS',

  FETCH_MERCHANT_PROFILE_LOGS: 'FETCH_MERCHANT_PROFILE_LOGS',
  LOADING_MORE_MERCHANT_PROFILE_LOGS: 'LOADING_MORE_MERCHANT_PROFILE_LOGS',
  FETCHING_MERCHANT_PROFILE_LOGS: 'FETCHING_MERCHANT_PROFILE_LOGS',
  FETCH_MERCHANT_PROFILE_LOGS_SUCCESS: 'FETCH_MERCHANT_PROFILE_LOGS_SUCCESS',
  FETCH_MERCHANT_PROFILE_LOGS_FAILED: 'FETCH_MERCHANT_PROFILE_LOGS_FAILED',
  PUSH_MERCHANT_PROFILE_LOGS: 'PUSH_MERCHANT_PROFILE_LOGS',
  RESET_MERCHANT_PROFILE_LOGS: 'RESET_MERCHANT_PROFILE_LOGS',

  GENERATE_MERCHANT_CREDENTIAL: 'GENERATE_MERCHANT_CREDENTIAL',
  GENERATING_MERCHANT_CREDENTIAL: 'GENERATING_MERCHANT_CREDENTIAL',
  GENERATE_MERCHANT_CREDENTIAL_SUCCESS: 'GENERATE_MERCHANT_CREDENTIAL_SUCCESS',
  GENERATE_MERCHANT_CREDENTIAL_FAILED: 'GENERATE_MERCHANT_CREDENTIAL_FAILED',

  FETCH_MERCHANT_CREDENTIALS_BY_ID: 'FETCH_MERCHANT_CREDENTIALS_BY_ID',
  FETCHING_MERCHANT_CREDENTIALS_BY_ID: 'FETCHING_MERCHANT_CREDENTIALS_BY_ID',
  FETCH_MERCHANT_CREDENTIALS_BY_ID_SUCCESS: 'FETCH_MERCHANT_CREDENTIALS_BY_ID_SUCCESS',
  FETCH_MERCHANT_CREDENTIALS_BY_ID_FAILED: 'FETCH_MERCHANT_CREDENTIALS_BY_ID_FAILED',
  RESET_MERCHANT_CREDENTIALS_BY_ID: 'RESET_MERCHANT_CREDENTIALS_BY_ID',

  ADD_MERCHANT_PAYMENT_CHANNEL: 'ADD_MERCHANT_PAYMENT_CHANNEL',
  ADDING_MERCHANT_PAYMENT_CHANNEL: 'ADDING_MERCHANT_PAYMENT_CHANNEL',
  ADD_MERCHANT_PAYMENT_CHANNEL_SUCCESS: 'ADD_MERCHANT_PAYMENT_CHANNEL_SUCCESS',
  ADD_MERCHANT_PAYMENT_CHANNEL_FAILED: 'ADD_MERCHANT_PAYMENT_CHANNEL_FAILED',

  FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID: 'FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID',
  FETCHING_MERCHANT_PAYMENT_CHANNELS_BY_ID: 'FETCHING_MERCHANT_PAYMENT_CHANNELS_BY_ID',
  FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_SUCCESS: 'FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_SUCCESS',
  FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_FAILED: 'FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_FAILED',
  RESET_MERCHANT_PAYMENT_CHANNELS_BY_ID: 'RESET_MERCHANT_PAYMENT_CHANNELS_BY_ID',

  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID: 'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID',
  FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID:
    'FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID',
  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_SUCCESS:
    'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_SUCCESS',
  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_FAILED:
    'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_FAILED',
  RESET_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID: 'RESET_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID',

  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL: 'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL',
  UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL: 'UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_SUCCESS: 'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_SUCCESS',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED: 'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED',

  UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS: 'UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS',
  UPDATING_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS: 'UPDATING_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS',
  UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_SUCCESS:
    'UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_SUCCESS',
  UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED:
    'UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED',

  UPDATE_MERCHANT_PAYMENT_CHANNEL: 'UPDATE_MERCHANT_PAYMENT_CHANNEL',
  UPDATING_MERCHANT_PAYMENT_CHANNEL: 'UPDATING_MERCHANT_PAYMENT_CHANNEL',
  UPDATE_MERCHANT_PAYMENT_CHANNEL_SUCCESS: 'UPDATE_MERCHANT_PAYMENT_CHANNEL_SUCCESS',
  UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED: 'UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED',

  UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS: 'UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS',
  UPDATING_ACTIVE_PAYMENT_CHANNEL_STATUS: 'UPDATING_ACTIVE_PAYMENT_CHANNEL_STATUS',
  UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_SUCCESS: 'UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_SUCCESS',
  UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED: 'UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED',

  DELETE_MERCHANT_PAYMENT_CHANNEL: 'DELETE_MERCHANT_PAYMENT_CHANNEL',
  DELETING_MERCHANT_PAYMENT_CHANNEL: 'DELETING_MERCHANT_PAYMENT_CHANNEL',
  DELETE_MERCHANT_PAYMENT_CHANNEL_SUCCESS: 'DELETE_MERCHANT_PAYMENT_CHANNEL_SUCCESS',
  DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED: 'DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED',

  STORE_TESTING_PROOF_FILES_FOR_UPLOAD: 'STORE_TESTING_PROOF_FILES_FOR_UPLOAD',
  STORING_TESTING_PROOF_FILES_FOR_UPLOAD: 'STORING_TESTING_PROOF_FILES_FOR_UPLOAD',
  STORE_TESTING_PROOF_FILES_FOR_UPLOAD_SUCCESS: 'STORE_TESTING_PROOF_FILES_FOR_UPLOAD_SUCCESS',
  STORE_TESTING_PROOF_FILES_FOR_UPLOAD_FAILED: 'STORE_TESTING_PROOF_FILES_FOR_UPLOAD_FAILED',

  UPLOAD_TESTING_PROOF_FILES: 'UPLOAD_TESTING_PROOF_FILES',
  UPLOADING_TESTING_PROOF_FILES: 'UPLOADING_TESTING_PROOF_FILES',
  UPLOAD_TESTING_PROOF_FILES_SUCCESS: 'UPLOAD_TESTING_PROOF_FILES_SUCCESS',
  UPLOAD_TESTING_PROOF_FILES_FAILED: 'UPLOAD_TESTING_PROOF_FILES_FAILED',

  DELETE_TESTING_PROOF_FILES: 'DELETE_TESTING_PROOF_FILES',
  DELETING_TESTING_PROOF_FILES: 'DELETING_TESTING_PROOF_FILES',
  DELETE_TESTING_PROOF_FILES_SUCCESS: 'DELETE_TESTING_PROOF_FILES_SUCCESS',
  DELETE_TESTING_PROOF_FILES_FAILED: 'DELETE_TESTING_PROOF_FILES_FAILED',

  FETCH_TESTING_PROOF_FILES_BY_ID: 'FETCH_TESTING_PROOF_FILES_BY_ID',
  FETCHING_TESTING_PROOF_FILES_BY_ID: 'FETCHING_TESTING_PROOF_FILES_BY_ID',
  FETCH_TESTING_PROOF_FILES_BY_ID_SUCCESS: 'FETCH_TESTING_PROOF_FILES_BY_ID_SUCCESS',
  FETCH_TESTING_PROOF_FILES_BY_ID_FAILED: 'FETCH_TESTING_PROOF_FILES_BY_ID_FAILED',
  RESET_TESTING_PROOF_FILES_BY_ID: 'RESET_TESTING_PROOF_FILES_BY_ID',

  DOWNLOAD_TESTING_PROOF_FILE: 'DOWNLOAD_TESTING_PROOF_FILE',
  DOWNLOADING_TESTING_PROOF_FILE: 'DOWNLOADING_TESTING_PROOF_FILE',
  DOWNLOAD_TESTING_PROOF_FILE_SUCCESS: 'DOWNLOAD_TESTING_PROOF_FILE_SUCCESS',
  DOWNLOAD_TESTING_PROOF_FILE_FAILED: 'DOWNLOAD_TESTING_PROOF_FILE_FAILED',

  DOWNLOAD_IRF_TESTING_PROOF_FILE: 'DOWNLOAD_IRF_TESTING_PROOF_FILE',
  DOWNLOADING_IRF_TESTING_PROOF_FILE: 'DOWNLOADING_IRF_TESTING_PROOF_FILE',
  DOWNLOAD_IRF_TESTING_PROOF_FILE_SUCCESS: 'DOWNLOAD_IRF_TESTING_PROOF_FILE_SUCCESS',
  DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED: 'DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED',

  RELEASE_TOS_CREDENTIALS: 'RELEASE_TOS_CREDENTIALS',
  RELEASING_TOS_CREDENTIALS: 'RELEASING_TOS_CREDENTIALS',
  RELEASE_TOS_CREDENTIALS_SUCCESS: 'RELEASE_TOS_CREDENTIALS_SUCCESS',
  RELEASE_TOS_CREDENTIALS_FAILED: 'RELEASE_TOS_CREDENTIALS_FAILED',

  RELEASE_TOS_CONFIGURATION: 'RELEASE_TOS_CONFIGURATION',
  RELEASING_TOS_CONFIGURATION: 'RELEASING_TOS_CONFIGURATION',
  RELEASE_TOS_CONFIGURATION_SUCCESS: 'RELEASE_TOS_CONFIGURATION_SUCCESS',
  RELEASE_TOS_CONFIGURATION_FAILED: 'RELEASE_TOS_CONFIGURATION_SUCCESS',

  RELEASE_STATUS_CONFIGURATION: 'RELEASE_STATUS_CONFIGURATION',
  RELEASING_STATUS_CONFIGURATION: 'RELEASING_STATUS_CONFIGURATION',
  RELEASE_STATUS_CONFIGURATION_SUCCESS: 'RELEASE_STATUS_CONFIGURATION_SUCCESS',
  RELEASE_STATUS_CONFIGURATION_FAILED: 'RELEASE_STATUS_CONFIGURATION_FAILED',

  STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD: 'STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD',
  STORING_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD: 'STORING_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD',
  STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_SUCCESS:
    'STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_SUCCESS',
  STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_FAILED:
    'STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_FAILED',
  RESET_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD: 'STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD',

  UPLOAD_TESTING_PROOF_IRF_FILES: 'UPLOAD_TESTING_PROOF_IRF_FILES',
  UPLOADING_TESTING_PROOF_IRF_FILES: 'UPLOADING_TESTING_PROOF_IRF_FILES',
  UPLOAD_TESTING_PROOF_IRF_FILES_SUCCESS: 'UPLOAD_TESTING_PROOF_IRF_FILES_SUCCESS',
  UPLOAD_TESTING_PROOF_IRF_FILES_FAILED: 'UPLOAD_TESTING_PROOF_IRF_FILES_FAILED',

  FETCH_TESTING_IRF_PROOF_FILES_BY_ID: 'FETCH_TESTING_IRF_PROOF_FILES_BY_ID',
  FETCHING_TESTING_IRF_PROOF_FILES_BY_ID: 'FETCHING_TESTING_IRF_PROOF_FILES_BY_ID',
  FETCH_TESTING_IRF_PROOF_FILES_BY_ID_SUCCESS: 'FETCH_TESTING_IRF_PROOF_FILES_BY_ID_SUCCESS',
  FETCH_TESTING_IRF_PROOF_FILES_BY_ID_FAILED: 'FETCH_TESTING_IRF_PROOF_FILES_BY_ID_FAILED',

  DOWNLOAD_TESTING_IRF_PROOF_FILE: 'DOWNLOAD_TESTING_IRF_PROOF_FILE',
  DOWNLOADING_TESTING_IRF_PROOF_FILE: 'DOWNLOADING_TESTING_IRF_PROOF_FILE',
  DOWNLOAD_TESTING_IRF_PROOF_FILE_SUCCESS: 'DOWNLOAD_TESTING_IRF_PROOF_FILE_SUCCESS',
  DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED: 'DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED',

  DELETE_TESTING_MERCHANT_PROOF_FILE: 'DELETE_TESTING_MERCHANT_PROOF_FILE',
  DELETING_TESTING_MERCHANT_PROOF_FILE: 'DELETING_TESTING_MERCHANT_PROOF_FILE',
  DELETE_TESTING_MERCHANT_PROOF_FILE_SUCCESS: 'DELETE_TESTING_MERCHANT_PROOF_FILE_SUCCESS',
  DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED: 'DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED',

  ADD_MERCHANT_CERTIFICATE: 'ADD_MERCHANT_CERTIFICATE',
  ADDING_MERCHANT_CERTIFICATE: 'ADDING_MERCHANT_CERTIFICATE',
  ADD_MERCHANT_CERTIFICATE_SUCCESS: 'ADD_MERCHANT_CERTIFICATE_SUCCESS',
  ADD_MERCHANT_CERTIFICATE_FAILED: 'ADD_MERCHANT_CERTIFICATE_FAILED',

  FETCH_TEST_MERCHANT_CERTIFICATES: 'FETCH_TEST_MERCHANT_CERTIFICATES',
  FETCHING_TEST_MERCHANT_CERTIFICATES: 'FETCHING_TEST_MERCHANT_CERTIFICATES',
  FETCH_TEST_MERCHANT_CERTIFICATES_SUCCESS: 'FETCH_TEST_MERCHANT_CERTIFICATES_SUCCESS',
  FETCH_TEST_MERCHANT_CERTIFICATES_FAILED: 'FETCH_TEST_MERCHANT_CERTIFICATES_FAILED',

  FETCH_PROD_MERCHANT_CERTIFICATES: 'FETCH_PROD_MERCHANT_CERTIFICATES',
  FETCHING_PROD_MERCHANT_CERTIFICATES: 'FETCHING_PROD_MERCHANT_CERTIFICATES',
  FETCH_PROD_MERCHANT_CERTIFICATES_SUCCESS: 'FETCH_PROD_MERCHANT_CERTIFICATES_SUCCESS',
  FETCH_PROD_MERCHANT_CERTIFICATES_FAILED: 'FETCH_PROD_MERCHANT_CERTIFICATES_FAILED',

  UPDATE_MERCHANT_CERTIFICATE: 'UPDATE_MERCHANT_CERTIFICATE',
  UPDATING_MERCHANT_CERTIFICATE: 'UPDATING_MERCHANT_CERTIFICATE',
  UPDATE_MERCHANT_CERTIFICATE_SUCCESS: 'UPDATE_MERCHANT_CERTIFICATE_SUCCESS',
  UPDATE_MERCHANT_CERTIFICATE_FAILED: 'UPDATE_MERCHANT_CERTIFICATE_FAILED',

  UPDATE_MERCHANT_CERTIFICATE_STATUS: 'UPDATE_MERCHANT_CERTIFICATE_STATUS',
  UPDATING_MERCHANT_CERTIFICATE_STATUS: 'UPDATING_MERCHANT_CERTIFICATE_STATUS',
  UPDATE_MERCHANT_CERTIFICATE_STATUS_SUCCESS: 'UPDATE_MERCHANT_CERTIFICATE_STATUS_SUCCESS',
  UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED: 'UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED',

  RESET_TEST_MERCHANT_CERTIFICATES: 'RESET_TEST_MERCHANT_CERTIFICATES',
  RESET_PROD_MERCHANT_CERTIFICATES: 'RESET_PROD_MERCHANT_CERTIFICATES',

  FETCH_BUSINESS_TYPE_REQUIREMENT: 'FETCH_BUSINESS_TYPE_REQUIREMENT',
  FETCHING_BUSINESS_TYPE_REQUIREMENT: 'FETCHING_BUSINESS_TYPE_REQUIREMENT',
  FETCH_BUSINESS_TYPE_REQUIREMENT_SUCCESS: 'FETCH_BUSINESS_TYPE_REQUIREMENT_SUCCESS',
  FETCH_BUSINESS_TYPE_REQUIREMENT_FAILED: 'FETCH_BUSINESS_TYPE_REQUIREMENT_FAILED',

  SAVE_UPLOADED_FILE_METADATA: 'SAVE_UPLOADED_FILE_METADATA',
  SAVING_UPLOADED_FILE_METADATA: 'SAVING_UPLOADED_FILE_METADATA',
  SAVE_UPLOADED_FILE_METADATA_SUCCESS: 'SAVE_UPLOADED_FILE_METADATA_SUCCESS',
  SAVE_UPLOADED_FILE_METADATA_FAILED: 'SAVE_UPLOADED_FILE_METADATA_FAILED',

  UPDATE_UPLOADED_FILE_METADATA: 'UPDATE_UPLOADED_FILE_METADATA',
  UPDATE_UPLOADED_FILE_METADATA_LOADING: 'UPDATE_UPLOADED_FILE_METADATA_LOADING',
  UPDATE_UPLOADED_FILE_METADATA_SUCCESS: 'UPDATE_UPLOADED_FILE_METADATA_SUCCESS',
  UPDATE_UPLOADED_FILE_METADATA_FAILED: 'UPDATE_UPLOADED_FILE_METADATA_FAILED',

  //[Migrate to PTI Dashboard Merchant Config]
  MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG: 'MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG',
  MIGRATING_MERCHANT_PAYMENT_CHANNEL_CONFIG: 'MIGRATING_MERCHANT_PAYMENT_CHANNEL_CONFIG',
  MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_SUCCESS:
    'MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_SUCCESS',
  MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_FAILED: 'MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_FAILED',

  DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL: 'DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL',
  DELETING_RM_ENDORSE_IRF_PAYMENT_CHANNEL: 'DELETING_RM_ENDORSE_IRF_PAYMENT_CHANNEL',
  DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_SUCCESS: 'DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_SUCCESS',
  DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED: 'DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED',

  FETCH_MERCHANT_CREDENTIALS: 'FETCH_MERCHANT_CREDENTIALS',
  FETCHING_MERCHANT_CREDENTIALS: 'FETCHING_MERCHANT_CREDENTIALS',
  FETCH_MERCHANT_CREDENTIALS_SUCCESS: 'FETCH_MERCHANT_CREDENTIALS_SUCCESS',
  FETCH_MERCHANT_CREDENTIALS_FAILED: 'FETCH_MERCHANT_CREDENTIALS_FAILED',

  FETCH_MERCHANT_CREDENTIAL_BY_ID: 'FETCH_MERCHANT_CREDENTIAL_BY_ID',
  FETCHING_MERCHANT_CREDENTIAL_BY_ID: 'FETCHING_MERCHANT_CREDENTIAL_BY_ID',
  FETCH_MERCHANT_CREDENTIAL_BY_ID_SUCCESS: 'FETCH_MERCHANT_CREDENTIAL_BY_ID_SUCCESS',
  FETCH_MERCHANT_CREDENTIAL_BY_ID_FAILED: 'FETCH_MERCHANT_CREDENTIAL_BY_ID_FAILED',

  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID: 'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID',
  FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID:
    'FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID',
  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_SUCCESS:
    'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_SUCCESS',
  FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_FAILED:
    'FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_FAILED',

  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID: 'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID',
  UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID:
    'UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS:
    'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED:
    'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED',

  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS:
    'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS',
  UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS:
    'UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_SUCCESS:
    'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_SUCCESS',
  UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_FAILED:
    'UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_FAILED',

  MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID: 'MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID',
  MIGRATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID:
    'MIGRATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID',
  MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS:
    'MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS',
  MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED:
    'MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED',

  RESET_MERCHANT_CREDENTIAL_BY_ID: 'RESET_MERCHANT_CREDENTIAL_BY_ID',

  LOAD_MORE_MERCHANT_CREDENTIALS: 'LOAD_MORE_MERCHANT_CREDENTIALS',
  LOADING_MORE_MERCHANT_CREDENTIALS: 'LOADING_MORE_MERCHANT_CREDENTIALS',
  LOAD_MORE_MERCHANT_CREDENTIALS_SUCCESS: 'LOAD_MORE_MERCHANT_CREDENTIALS_SUCCESS',
  LOAD_MORE_MERCHANT_CREDENTIALS_FAILED: 'LOAD_MORE_MERCHANT_CREDENTIALS_FAILED',

  LOAD_MORE_MERCHANT_AUDIT_LOGS: 'LOAD_MORE_MERCHANT_AUDIT_LOGS',
  LOADING_MORE_MERCHANT_AUDIT_LOGS: 'LOADING_MORE_MERCHANT_AUDIT_LOGS',
  LOAD_MORE_MERCHANT_AUDIT_LOGS_SUCCESS: 'LOAD_MORE_MERCHANT_AUDIT_LOGS_SUCCESS',
  LOAD_MORE_MERCHANT_AUDIT_LOGS_FAILED: 'LOAD_MORE_MERCHANT_AUDIT_LOGS_FAILED',

  FETCH_MID_AUDIT_LOGS: 'FETCH_MID_AUDIT_LOGS',
  FETCHING_MID_AUDIT_LOGS: 'FETCHING_MID_AUDIT_LOGS',
  FETCH_MID_AUDIT_LOGS_SUCCESS: 'FETCH_MID_AUDIT_LOGS_SUCCESS',
  FETCH_MID_AUDIT_LOGS_FAILED: 'FETCH_MID_AUDIT_LOGS_FAILED',

  LOAD_MORE_MID_AUDIT_LOGS: 'LOAD_MORE_MID_AUDIT_LOGS',
  LOADING_MORE_MID_AUDIT_LOGS: 'LOADING_MORE_MID_AUDIT_LOGS',
  LOAD_MORE_MID_AUDIT_LOGS_SUCCESS: 'LOAD_MORE_MID_AUDIT_LOGS_SUCCESS',
  LOAD_MORE_MID_AUDIT_LOGS_FAILED: 'LOAD_MORE_MID_AUDIT_LOGS_FAILED',

  UPDATE_AUDIT_LOGS: 'UPDATE_AUDIT_LOGS',

  ADD_NEW_MERCHANT_CERTIFICATE: 'ADD_NEW_MERCHANT_CERTIFICATE',
  ADDING_NEW_MERCHANT_CERTIFICATE: 'ADDING_NEW_MERCHANT_CERTIFICATE',
  ADD_NEW_MERCHANT_CERTIFICATE_SUCCESS: 'ADD_NEW_MERCHANT_CERTIFICATE_SUCCESS',
  ADD_NEW_MERCHANT_CERTIFICATE_FAILED: 'ADD_NEW_MERCHANT_CERTIFICATE_FAILED',

  UPDATE_MERCHANT_CERTIFICATE_V2: 'UPDATE_MERCHANT_CERTIFICATE_V2',
  UPDATING_MERCHANT_CERTIFICATE_V2: 'UPDATING_MERCHANT_CERTIFICATE_V2',
  UPDATE_MERCHANT_CERTIFICATE_V2_SUCCESS: 'UPDATE_MERCHANT_CERTIFICATE_V2_SUCCESS',
  UPDATE_MERCHANT_CERTIFICATE_V2_FAILED: 'UPDATE_MERCHANT_CERTIFICATE_V2_FAILED',

  UPDATE_MID_CERTIFICATE: 'UPDATE_MID_CERTIFICATE',
  UPDATING_MID_CERTIFICATE: 'UPDATING_MID_CERTIFICATE',
  UPDATE_MID_CERTIFICATE_SUCCESS: 'UPDATE_MID_CERTIFICATE_SUCCESS',
  UPDATE_MID_CERTIFICATE_FAILED: 'UPDATE_MID_CERTIFICATE_FAILED',

  FETCH_MERCHANT_CERTIFICATES: 'FETCH_MERCHANT_CERTIFICATES',
  FETCHING_MERCHANT_CERTIFICATES: 'FETCHING_MERCHANT_CERTIFICATES',
  FETCH_MERCHANT_CERTIFICATES_SUCCESS: 'FETCH_MERCHANT_CERTIFICATES_SUCCESS',
  FETCH_MERCHANT_CERTIFICATES_FAILED: 'FETCH_MERCHANT_CERTIFICATES_FAILED',

  FETCH_COMPANY_PROFILE_DATA: 'FETCH_COMPANY_PROFILE_DATA',
  FETCHING_COMPANY_PROFILE_DATA: 'FETCHING_COMPANY_PROFILE_DATA',
  FETCH_COMPANY_PROFILE_DATA_SUCCESS: 'FETCH_COMPANY_PROFILE_DATA_SUCCESS',
  FETCH_COMPANY_PROFILE_DATA_FAILED: 'FETCH_COMPANY_PROFILE_DATA_FAILED',

  RESET_MERCHANT_CERTIFICATES: 'RESET_MERCHANT_CERTIFICATES',

  RESET_MERCHANT_CREDENTIALS: 'RESET_MERCHANT_CREDENTIALS',

  CLEAR_MERCHANT_DETAILS_MESSAGE: 'CLEAR_MERCHANT_DETAILS_MESSAGE',

  GET_S3_FILE_URL: 'GET_S3_FILE_URL',

  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  resetTokenData: payload => ({
    type: actions.RESET_TOKEN_DATA,
    payload
  }),

  newResetPassword: payload => ({
    type: actions.NEW_RESET_MERCHANT_USER_PASSWORD,
    payload
  }),

  resetErrorMessageHandler: () => ({
    type: actions.RESET_ERROR_MESSAGE,
    payload: null,
    isError: false
  }),

  fetchAllMerchants: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_DATA,
    payload,
    pagination
  }),

  resetMerchantList: () => ({
    type: actions.RESET_MERCHANT_LIST
  }),

  fetchMerchantFiles: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_FILES,
    payload,
    pagination
  }),

  resetMerchantFiles: () => ({
    type: actions.RESET_MERCHANT_FILES
  }),

  fetchMerchantConfiguration: payload => ({
    type: actions.FETCH_MERCHANT_CONFIG_DATA,
    payload
  }),

  fetchMerchantSettingsType: payload => ({
    type: actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA,
    payload
  }),

  resetMerchantConfig: () => ({
    type: actions.RESET_MERCHANT_CONFIG_DATA
  }),

  fetchAmountLevel: payload => ({
    type: actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA,
    payload
  }),

  fetchElasticMerchants: payload => ({
    type: actions.FETCH_ELASTIC_MERCHANT_DATA,
    payload
  }),

  fetchParentMerchants: payload => ({
    type: actions.FETCH_PARENT_MERCHANT_DATA,
    payload
  }),

  fetchMerchantByID: payload => ({
    type: actions.FETCH_MERCHANT_DATA_BY_ID,
    payload
  }),

  fetchPaybizDetailsData: payload => ({
    type: actions.FETCH_PAYBIZ_DETAILS_BY_ID,
    payload
  }),

  fetchPaybizMerchants: payload => ({
    type: actions.FETCH_PAYBIZ_MERCHANTS,
    payload
  }),

  resetPaybizDetails: () => ({
    type: actions.RESET_PAYBIZ_DETAILS
  }),

  fetchMerchantPChannelsByID: payload => ({
    type: actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID,
    payload
  }),

  fetchTestPtiMerchantUsers: (payload, pagination) => ({
    type: actions.FETCH_PTI_TEST_MERCHANT_USERS,
    payload,
    pagination
  }),
  resetTestPtiMerchantUsers: () => ({
    type: actions.RESET_PTI_TEST_MERCHANT_USERS
  }),

  fetchProdPtiMerchantUsers: (payload, pagination) => ({
    type: actions.FETCH_PTI_PROD_MERCHANT_USERS,
    payload,
    pagination
  }),

  resetProdPtiMerchantUsers: () => ({
    type: actions.RESET_PTI_PROD_MERCHANT_USERS
  }),

  fetchPtiMerchantUsers: (payload, pagination) => ({
    type: actions.FETCH_PTI_MERCHANT_USERS,
    payload,
    pagination
  }),

  addPtiDashboardUser: payload => ({
    type: actions.ADD_PTI_DASHBOARD_USER,
    payload
  }),

  updatePtiDashboardUser: payload => ({
    type: actions.UPDATE_PTI_DASHBOARD_USER,
    payload
  }),

  registerDashboardMerchantAccount: payload => ({
    type: actions.REGISTER_PTI_DASHBOARD_USER,
    payload
  }),

  fetchInvitedMerchantUserDetails: payload => ({
    type: actions.FETCH_INVITED_MERCHANT_DATA,
    payload
  }),

  fetchMerchantLogsByID: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_LOGS_DATA_BY_ID,
    payload,
    pagination
  }),

  addNewMerchant: payload => ({
    type: actions.ADD_MERCHANT_DATA,
    payload
  }),

  inviteNewMerchant: payload => ({
    type: actions.INVITE_MERCHANT_DATA,
    payload
  }),

  fetchInvitedMerchantDetails: payload => ({
    type: actions.FETCH_INVITED_MERCHANT_DATA,
    payload
  }),

  logAccessMerchantInvite: (payload, id) => ({
    type: actions.LOG_ACCESS_MERCHANT_INVITE_DATA,
    payload,
    id
  }),

  deleteMerchant: payload => ({
    type: actions.DELETE_MERCHANT_DATA,
    payload
  }),

  filterMerchants: payload => ({
    type: actions.FILTER_MERCHANT,
    payload
  }),

  editMigratedMid: (payload, id) => ({
    type: actions.EDIT_MIGRATED_MID,
    payload,
    id
  }),

  editMerchantBasicInformation: (payload, id) => ({
    type: actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA,
    payload,
    id
  }),

  editMerchantConfiguration: (payload, id) => ({
    type: actions.EDIT_MERCHANT_CONFIG_DATA,
    payload,
    id
  }),

  editMerchantOwnerInformation: (payload, id) => ({
    type: actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA,
    payload,
    id
  }),

  editMerchantContactInformation: (payload, id) => ({
    type: actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA,
    payload,
    id
  }),

  editMerchantServiceInformation: (payload, id) => ({
    type: actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA,
    payload,
    id
  }),

  editMerchantPchannelData: (payload, id, request) => ({
    type: actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA,
    payload,
    id,
    request
  }),

  resetMerchantData: payload => ({
    type: actions.RESET_MERCHANT_DATA,
    payload
  }),

  resetMerchantInformationData: () => ({
    type: actions.RESET_MERCHANT_INFORMATION_DATA
  }),

  resetMerchantPChannelData: payload => ({
    type: actions.RESET_MERCHANT_PCHANNEL_DATA,
    payload
  }),

  resetMerchantLogsData: payload => ({
    type: actions.RESET_MERCHANT_LOGS_DATA,
    payload
  }),

  fetchFileManagementByMerchantID: (payload, pagination) => ({
    type: actions.FETCH_FILE_MANAGEMENT_DATA,
    payload,
    pagination
  }),

  resetFileManagementData: payload => ({
    type: actions.RESET_FILE_MANAGEMENT_DATA,
    payload
  }),

  uploadFileData: (payload, pagination) => ({
    type: actions.UPLOAD_FILE_DATA,
    payload,
    pagination
  }),

  downloadFileData: payload => ({
    type: actions.DOWNLOAD_FILE_DATA,
    payload
  }),

  removeFileDataFromStorage: payload => ({
    type: actions.REMOVE_FILE_DATA_STORAGE,
    payload
  }),

  deleteFileData: (payload, pagination) => ({
    type: actions.DELETE_FILE_DATA,
    payload,
    pagination
  }),

  addMerchantSettingsType: payload => ({
    type: actions.ADD_MERCHANT_SETTINGS_TYPE,
    payload
  }),

  addMerchantAmountLevel: payload => ({
    type: actions.ADD_AMOUNT_LEVEL,
    payload
  }),

  addMerchantConfiguration: payload => ({
    type: actions.ADD_MERCHANT_CONFIGURATION_DATA,
    payload
  }),

  editMerchantAmountLevel: (payload, id) => ({
    type: actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA,
    payload,
    id
  }),
  editMerchantSettingsType: (payload, id) => ({
    type: actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA,
    payload,
    id
  }),
  fetchMerchantPChannelCredentialByID: payload => ({
    type: actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA,
    payload
  }),
  fetchMerchantFees: payload => ({
    type: actions.FETCH_MERCHANT_FEE_DATA,
    payload
  }),

  setupMerchantPChannelCredential: (payload, id) => ({
    type: actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA,
    payload,
    id
  }),

  setupMerchantFee: (payload, id) => ({
    type: actions.SETUP_MERCHANT_FEE_DATA,
    payload,
    id
  }),

  addMerchantInfo: payload => ({
    type: actions.ADD_MERCHANT_INFORMATION,
    payload
  }),

  fetchAllMerchantInfo: payload => ({
    type: actions.FETCH_ALL_MERCHANT_INFORMATION,
    payload
  }),

  fetchMerchantInfoById: (payload, id) => ({
    type: actions.FETCH_MERCHANT_INFO_BY_ID,
    payload,
    id
  }),

  editMerchantInfo: (payload, id) => ({
    type: actions.EDIT_MERCHANT_INFO,
    payload,
    id
  }),

  fetchMISOptionsData: () => ({
    type: actions.FETCH_MIS_OPTIONS
  }),

  fetchMerchantMISDetails: payload => ({
    type: actions.FETCH_MIS_MERCHANT_DETAILS,
    payload
  }),

  fetchKybLinkStatus: payload => ({
    type: actions.FETCH_KYB_LINK_STATUS,
    payload
  }),

  logAccessMIS: (payload, id) => ({
    type: actions.LOG_ACCESS_MIS,
    payload,
    id
  }),

  saveMISDraft: payload => ({
    type: actions.SAVE_MIS_DRAFT,
    payload
  }),
  submitMISFormData: payload => ({
    type: actions.SUBMIT_MIS_FORM_DATA,
    payload
  }),

  fetchAllMerchantFromOnboarding: (payload, currentList) => ({
    type: actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING,
    payload,
    currentList
  }),

  fetchMerchantServicesAndPaymentChannels: payload => ({
    type: actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS,
    payload
  }),

  editMerchantService: payload => ({
    type: actions.EDIT_MERCHANT_SERVICE,
    payload
  }),

  editMerchantPaymentChannel: (urls, payload) => ({
    type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL,
    urls,
    payload
  }),

  fetchAllCosmosLeadAndMerchant: payload => ({
    type: actions.FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS,
    payload
  }),

  fetchExistingMerchantLogs: (payload, pagination) => ({
    type: actions.FETCH_EXISTING_MERCHANT_LOGS,
    payload,
    pagination
  }),

  fetchAllCompanyInformation: payload => ({
    type: actions.FETCH_COMPANY_INFORMATION_DATA,
    payload
  }),

  addCompanyInformation: payload => ({
    type: actions.ADD_COMPANY_INFORMATION,
    payload
  }),

  editCompanyInformation: (id, payload) => ({
    type: actions.EDIT_COMPANY_INFORMATION,
    id,
    payload
  }),

  downloadMerchantFile: payload => ({
    type: actions.DOWNLOAD_MERCHANT_FILE,
    payload
  }),

  fetchAllParentMerchants: () => ({
    type: actions.FETCH_ALL_PARENT_MERCHANTS
  }),

  migrateMerchantInfo: payload => ({
    type: actions.MIGRATE_MERCHANT_INFORMATION,
    payload
  }),

  fetchMerchantInfoMIDs: payload => ({
    type: actions.FETCH_MERCHANT_INFO_MIDS,
    payload
  }),

  fetchIntegrationFormRequests: (payload, pagination) => ({
    type: actions.FETCH_INTEGRATION_FORM_REQUESTS,
    payload,
    pagination
  }),

  fetchIntegrationFormRequestById: payload => ({
    type: actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID,
    payload
  }),

  resetIntegrationFormRequestById: () => ({
    type: actions.RESET_INTEGRATION_FORM_REQUEST_BY_ID
  }),

  editIntegrationChannelSubMID: (payload, id) => ({
    type: actions.EDIT_INTEGRATION_CHANNEL_SUB_MID,
    payload,
    id
  }),

  assignTOSToIRF: (payload, id) => ({
    type: actions.ASSIGN_TOS_TO_IRF,
    payload,
    id
  }),

  generateIntegrationRequestFormReport: payload => ({
    type: actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT,
    payload
  }),

  downloadIntegrationRequestFormReport: payload => ({
    type: actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT,
    payload
  }),

  fetchAllIntegrationRequestFormReportData: (payload, pagination) => ({
    type: actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA,
    payload,
    pagination
  }),

  updateIntegrationFormRequestStatus: (payload, id) => ({
    type: actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS,
    payload,
    id
  }),

  fetchIntegrationFormLogs: (payload, pagination) => ({
    type: actions.FETCH_INTEGRATION_FORM_LOGS,
    payload,
    pagination
  }),

  fetchMerchantProfileLogs: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_PROFILE_LOGS,
    payload,
    pagination
  }),

  fetchMerchantCredentialsById: payload => ({
    type: actions.FETCH_MERCHANT_CREDENTIALS_BY_ID,
    payload
  }),

  generateMerchantCredential: (payload, reducerName) => ({
    type: actions.GENERATE_MERCHANT_CREDENTIAL,
    payload,
    reducerName
  }),

  addMerchantPaymentChannel: payload => ({
    type: actions.ADD_MERCHANT_PAYMENT_CHANNEL,
    payload
  }),

  fetchMerchantPaymentChannelsById: payload => ({
    type: actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID,
    payload
  }),

  getS3UrlsTestingProofFiles: (key, files) => ({
    type: actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD,
    key,
    files
  }),

  uploadTestingProofFiles: (urls, payload) => ({
    type: actions.UPLOAD_TESTING_PROOF_FILES,
    urls,
    payload
  }),

  deleteTestingProofFiles: payload => ({
    type: actions.DELETE_TESTING_PROOF_FILES,
    payload
  }),

  fetchTestingProofFilesById: payload => ({
    type: actions.FETCH_TESTING_PROOF_FILES_BY_ID,
    payload
  }),

  resetTestingProofFilesById: payload => ({
    type: actions.RESET_TESTING_PROOF_FILES_BY_ID,
    payload
  }),

  downloadTestingProofFile: payload => ({
    type: actions.DOWNLOAD_TESTING_PROOF_FILE,
    payload
  }),

  downloadIRFTestingProofFile: payload => ({
    type: actions.DOWNLOAD_IRF_TESTING_PROOF_FILE,
    payload
  }),

  updateMerchantPaymentChannel: payload => ({
    type: actions.UPDATE_MERCHANT_PAYMENT_CHANNEL,
    payload
  }),

  deleteMerchantPaymentChannel: payload => ({
    type: actions.DELETE_MERCHANT_PAYMENT_CHANNEL,
    payload
  }),

  updateActivePaymentChannelStatus: payload => ({
    type: actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS,
    payload
  }),

  fetchMerchantKrakenPaymentChannelsById: payload => ({
    type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID,
    payload
  }),

  updateMerchantKrakenPaymentChannel: payload => ({
    type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL,
    payload
  }),

  updateActiveKrakenPaymentChannelStatus: payload => ({
    type: actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS,
    payload
  }),

  releaseTOSCredentials: payload => ({
    type: actions.RELEASE_TOS_CREDENTIALS,
    payload
  }),

  releaseTOSConfiguration: payload => ({
    type: actions.RELEASE_TOS_CONFIGURATION,
    payload
  }),

  getS3UrlsForIRFProdProofTestingFiles: (key, files) => ({
    type: actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD,
    key,
    files
  }),

  resetS3UrlsForIRFProdProofTestingFiles: () => ({
    type: actions.RESET_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD
  }),

  uploadTestingIrfProofFiles: (urls, payload) => ({
    type: actions.UPLOAD_TESTING_PROOF_IRF_FILES,
    urls,
    payload
  }),

  fetchTestingIrfProofFilesById: payload => ({
    type: actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID,
    payload
  }),

  downloadTestingIrfProofFile: payload => ({
    type: actions.DOWNLOAD_TESTING_IRF_PROOF_FILE,
    payload
  }),

  deleteTestingMerchantProofFile: payload => ({
    type: actions.DELETE_TESTING_MERCHANT_PROOF_FILE,
    payload
  }),

  addMerchantCertificate: payload => ({
    type: actions.ADD_MERCHANT_CERTIFICATE,
    payload
  }),

  fetchTestMerchantCertificates: payload => ({
    type: actions.FETCH_TEST_MERCHANT_CERTIFICATES,
    payload
  }),

  fetchProdMerchantCertificates: payload => ({
    type: actions.FETCH_PROD_MERCHANT_CERTIFICATES,
    payload
  }),

  updateMerchantCertificate: payload => ({
    type: actions.UPDATE_MERCHANT_CERTIFICATE,
    payload
  }),

  updateMerchantCertificateStatus: payload => ({
    type: actions.UPDATE_MERCHANT_CERTIFICATE_STATUS,
    payload
  }),

  resetTestMerchantCertificates: () => ({
    type: actions.RESET_TEST_MERCHANT_CERTIFICATES
  }),

  resetProdMerchantCertificates: () => ({
    type: actions.RESET_PROD_MERCHANT_CERTIFICATES
  }),

  fetchBusinessTypeRequiredFields: payload => ({
    type: actions.FETCH_BUSINESS_TYPE_REQUIREMENT,
    payload
  }),

  getS3FileUrl: payload => ({
    type: actions.GET_S3_FILE_URL,
    payload
  }),

  saveUploadedFileMetadata: payload => ({
    type: actions.SAVE_UPLOADED_FILE_METADATA,
    payload
  }),

  updateUploadedFileMetadata: payload => ({
    type: actions.UPDATE_UPLOADED_FILE_METADATA,
    payload
  }),

  migrateMerchantPaymentChannelConfig: payload => ({
    type: actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG,
    payload
  }),

  deleteRMEndorseIrfPaymentChannel: payload => ({
    type: actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL,
    payload
  }),

  fetchMerchantCredentialsByMerchantManagementId: (id, payload, pagination) => ({
    type: actions.FETCH_MERCHANT_CREDENTIALS,
    id,
    payload,
    pagination
  }),

  loadMoreMerchantCredentials: (id, payload, pagination) => ({
    type: actions.LOAD_MORE_MERCHANT_CREDENTIALS,
    id,
    payload,
    pagination
  }),

  resetMerchantCredentials: () => ({
    type: actions.RESET_MERCHANT_CREDENTIALS
  }),

  addNewMerchantCertificate: (payload, pagination) => ({
    type: actions.ADD_NEW_MERCHANT_CERTIFICATE,
    payload,
    pagination
  }),

  updateMerchantCertificateV2: (payload, pagination) => ({
    type: actions.UPDATE_MERCHANT_CERTIFICATE_V2,
    payload
  }),

  updateMidCertificate: payload => ({
    type: actions.UPDATE_MID_CERTIFICATE,
    payload
  }),

  fetchMerchantCertificates: (payload, pagination) => ({
    type: actions.FETCH_MERCHANT_CERTIFICATES,
    payload,
    pagination
  }),

  resetMerchantCertificates: () => ({
    type: actions.RESET_MERCHANT_CERTIFICATES
  }),

  clearMerchantDetailsMessage: () => ({
    type: actions.CLEAR_MERCHANT_DETAILS_MESSAGE
  }),

  fetchMerchantCredentialById: payload => ({
    type: actions.FETCH_MERCHANT_CREDENTIAL_BY_ID,
    payload
  }),

  fetchMerchantKrakenPaymentChannelsByMid: payload => ({
    type: actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID,
    payload
  }),

  updateMerchantKrakenPaymentChannelByMid: payload => ({
    type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID,
    payload
  }),

  updateMerchantKrakenPaymentChannelByMidStatus: payload => ({
    type: actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS,
    payload
  }),

  migrateMerchantKrakenPaymentByMid: payload => ({
    type: actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID,
    payload
  }),

  loadMoreMerchantAuditLogs: (payload, pagination) => ({
    type: actions.LOAD_MORE_MERCHANT_AUDIT_LOGS,
    payload,
    pagination
  }),

  fetchMidAuditLogs: payload => ({
    type: actions.FETCH_MID_AUDIT_LOGS,
    payload
    //pagination inside payload
  }),

  loadMoreMidAuditLogs: payload => ({
    type: actions.LOAD_MORE_MID_AUDIT_LOGS,
    payload
    //pagination inside payload
  }),

  resetMerchantCredentialById: () => ({
    type: actions.RESET_MERCHANT_CREDENTIAL_BY_ID
  }),

  fetchCompanyProfileData: (payload, pagination) => ({
    type: actions.FETCH_COMPANY_PROFILE_DATA,
    payload,
    pagination
  })
};
export default actions;
